import styled from 'styled-components';
import { FilterChipMixin } from '../../mixins/components/FilterChipMixin';
import { ToggleButton } from '../ToggleButton/ToggleButton';
export var StyledFilterChip = /*#__PURE__*/styled(ToggleButton).withConfig({
  displayName: "StyledFilterChip",
  componentId: "c11n-8-111-1__sc-1b5ahaw-0"
})(["", ""], FilterChipMixin);